import { SVGProps } from 'react';

export const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.707 3.86504L0.992351 0.150391L0 1.14274L4.707 5.84974L9.414 1.14274L8.42165 0.150391L4.707 3.86504Z"
      fill="currentColor"
    />
  </svg>
);
